export default __webpack_public_path__ + "static/media/miniatures.d6a0feb8.jpg";